const { getNumber } = require('../utils');
const { MyModal } = require('../MyModal');
// import MyModal from '../MyModal'
export default [
    {
        title: '机器人',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => getNumber(a.name) - getNumber(b.name),
        editable: true,
    },
    {
        title: '容器ID',
        type: 'string',
        dataIndex: 'containerGroupId',
        key: 'containerGroupId',
        editable: true,
    },
    {
        title: '云手机ID',
        type: 'string',
        dataIndex: 'instanceId',
        key: 'instanceId',
        editable: true,
    },
    {
        title: '密钥',
        type: 'string',
        dataIndex: 'keyPair',
        key: 'keyPair',
        editable: true,
    },
    {
        title: '日志',
        type: 'string',
        dataIndex: 'log',
        key: 'log',
        render: (text) => <MyModal log={text} />,
        editable: false,
    }
];